export default __webpack_public_path__ + "static/media/youtube_ico.0cf76865.svg";